export default __webpack_public_path__ + "static/media/640_dummy2016-reiseblog01-de.4b5c664f.png";